import router from '@/router'

export default{

  writeErrorResponse (store, data) {
    store.commit('writeErrorResponse', data)
  },

  resetErrorResponse (store) {
    store.commit('writeChangePasswordError', [])
    store.commit('writeErrorResponse', {
      cmd: false,
      error: false
    })
  },

  initInfos (store, data) {
    let roomsData = {}
    let skillsData = {}
    let settingsData = {}
    let headerData = {}

    skillsData.data = data.skills
    skillsData.cmd = 'get_skills'
    settingsData.data = data.settings
    settingsData.cmd = 'settings'
    roomsData.data = data.rooms
    roomsData.cmd = 'get_rooms'
    headerData.data = data.header_stats
    headerData.cmd = 'get_header_stats'

    store.commit('updateSkills', skillsData)
    store.commit('updateOwnSettings', settingsData)
    store.commit('updateRooms', roomsData)
    store.commit('updateHeaderStats', headerData)
  },

  updateLoginResponse (store, data) {
    store.commit('updateLoginResponse', data)
  },

  updateChangePassword (store, data) {
    store.commit('updateChangePassword', data)
  },

  updateResetPassword (store, data) {
    store.commit('updateResetPassword', data)
  },

  updateRooms (store, data) {
    store.commit('updateRooms', data)
  },

  updateSkills (store, data) {
    store.commit('updateSkills', data)
  },

  resetAppReady (store) {
    store.commit('setAppReady', false)
  },

  setAppReady (store) {
    store.commit('setAppReady', true)
    router.push({
      path: '/dashboard'
    })
  },

  updateMessages (store, data) {
    store.commit('updateMessages', data)
  },

  addMessage (store, data) {
    store.commit('addMessage', data)
  },

  setRoomForMessageRequest (store, data) {
    store.commit('setRoomForMessageRequest', data)
  },

  setFromeventForMessageRequest (store, data) {
    store.commit('setFromeventForMessageRequest', data)
  },

  setLasteventForMessageRequest (store, data) {
    store.commit('setLasteventForMessageRequest', data)
  },

  setRoomForJoinRequest (store, data) {
    store.commit('setRoomForJoinRequest', data)
  },

  updateJoinRoomResponse (store, data) {
    store.commit('updateJoinRoomResponse', data)
  },

  resetJoinRoomResponse (store) {
    store.commit('updateJoinRoomResponse', {
      cmd: 'join_room',
      room: '',
      history: []
    })
  },

  updateOwnSettings (store, data) {
    store.commit('updateOwnSettings', data)
  },

  updatePauseSetting (store, data) {
    store.commit('updatePauseSetting', data)
  },

  updateAgentSettings (store, data) {
    store.commit('updateAgentSettings', data.data)
  },

  resetAgentSettings (store) {
    store.commit('updateAgentSettings', {
      uuid: '',
      kind: '',
      email: '',
      first_name: '',
      last_name: '',
      last_login: '',
      skills: [],
      paused: false,
      max_rooms: 0
    })
  },

  setAgentUuidForSettingsRequest (store, data) {
    store.commit('setAgentUuidForSettingsRequest', data)
  },

  updateAgentsList (store, data) {
    store.commit('updateAgentsList', data)
  },

  resetAgentsList (store) {
    store.commit('updateAgentsList', {
      cmd: 'get_agents',
      data: []
    })
  },

  updateRoomData (store, data) {
    store.commit('updateRoomData', data)
  },

  setCurrentRoom (store, data) {
    store.commit('updateHistoryResponse', {
      cmd: 'get_history',
      room: '',
      data: []
    })
    store.commit('updateMessages', {
      room: '',
      messages: []
    })
    store.commit('setCurrentRoom', data)
  },

  setSkilForAgentRequest (store, data) {
    store.commit('setSkilForAgentRequest', data)
  },

  setRoomForCloseRequest (store, data) {
    store.commit('setRoomForCloseRequest', data)
  },

  updateCloseRoomResponse (store, data) {
    store.commit('updateCloseRoomResponse', data)
  },

  resetCloseRoomResponse (store) {
    store.commit('updateCloseRoomResponse', {
      cmd: 'close_room',
      room: '',
      result: ''
    })
  },

  setRoomForBlockRequest (store, data) {
    store.commit('setRoomForBlockRequest', data)
  },

  updateBlockRoomResponse (store, data) {
    store.commit('updateBlockRoomResponse', data)
  },

  resetBlockRoomResponse (store) {
    store.commit('updateBlockRoomResponse', {
      cmd: 'block_room',
      room: '',
      result: ''
    })
  },

  setRoomForTransferRequest (store, data) {
    store.commit('setRoomForTransferRequest', data)
  },

  setSKillForTransferRequest (store, data) {
    store.commit('setSKillForTransferRequest', data)
  },

  updateTransferRoomResponse (store, data) {
    store.commit('updateTransferRoomResponse', data)
  },

  resetTransferRoomResponse (store) {
    store.commit('updateTransferRoomResponse', {
      cmd: 'transfer_room',
      room: '',
      skill: '',
      result: ''
    })
  },

  setRoomForHistoryRequest (store, data) {
    store.commit('setRoomForHistoryRequest', data)
  },

  updateHistoryResponse (store, data) {
    store.commit('updateHistoryResponse', data)
  },

  setRoomForSendMessage (store, data) {
    store.commit('setRoomForSendMessage', data)
  },

  setContentForSendMessage (store, data) {
    store.commit('setContentForSendMessage', data)
    store.commit('setRichContentForSendMessage', [
      {
        kind: 'txt',
        txt: data
      }
    ])
  },

  updateGetProductsResponse (store, data) {
    store.commit('updateGetProductsResponse', data)
  },

  resetGetProductsResponse (store) {
    store.commit('updateGetProductsResponse', [])
  },

  setRoomForSendProductsRequest (store, data) {
    store.commit('setRoomForSendProductsRequest', data)
  },

  setContentForSendProducts (store, data) {
    let content = ''
    let richContent = []
    let kind = 'item'
    if (data.length > 1) kind = 'choice'
    data.forEach(element => {
      richContent.push({
        kind: kind,
        item: element
      })
      content += element.label + ': ' + element.desc + '\n'
    })
    store.commit('setContentForSendProducts', content)
    store.commit('setRichContentForSendProducts', richContent)
  },

  setContentForSendLocations (store, data) {
    let content = ''
    let richContent = []
    data.forEach(element => {
      richContent.push(element)
      content += element.location.label + '\n'
    })
    store.commit('setContentForSendLocations', content)
    store.commit('setRichContentForSendLocations', richContent)
  },

  setRoomForSendLocationsRequest (store, data) {
    store.commit('setRoomForSendLocationsRequest', data)
  },

  updateHeaderStats (store, data) {
    store.commit('updateHeaderStats', data)
  },

  resetHeaderStats (store) {
    store.commit('updateHeaderStats', {
      cmd: 'get_header_stats',
      data: {
        running_count: 0,
        average_waiting: 0,
        average_running: 0,
        average_sat: 0
      }
    })
  },

  updateGetStats (store, data) {
    store.commit('updateGetStats', data)
  },

  resetGetStats (store) {
    store.commit('updateGetStats', {
      cmd: 'get_stats',
      data: {
        waiting_count: 0,
        average_waiting: 0,
        average_running: 0,
        handle_rate: 0,
        closed_count: 0,
        details: []
      }
    })
  },

  setIntervalForGetStats (store, data) {
    store.commit('setIntervalForGetStats', data)
  },

  resetIntervalForGetStats (store) {
    store.commit('setIntervalForGetStats', null)
  },

  updateGetCsvStats (store, data) {
    store.commit('updateGetCsvStats', data)
  },

  resetGetCsvStats (store) {
    store.commit('updateGetCsvStats', {
      cmd: 'get_csv_stats',
      data: ''
    })
  },

  setIntervalForGetCsvStats (store, data) {
    store.commit('setIntervalForGetCsvStats', data)
  },

  resetIntervalForGetCsvStats (store) {
    store.commit('setIntervalForGetCsvStats', null)
  },

  updateGetSupervisorStats (store, data) {
    store.commit('updateGetSupervisorStats', data.data)
  },

  resetGetSupervisorStats (store) {
    store.commit('updateGetSupervisorStats', {
      waiting_count: 0,
      average_waiting: 0,
      average_running: 0,
      agent_count: 0,
      handle_rate: 0,
      closed_count_per_agent: 0,
      details: []
    })
  },

  setIntervalForGetSupervisorStats (store, data) {
    store.commit('setIntervalForGetSupervisorStats', data)
  },

  setAgentForGetSupervisorStats (store, data) {
    store.commit('setAgentForGetSupervisorStats', data)
  },

  setSkillForGetSupervisorStats (store, data) {
    store.commit('setSkillForGetSupervisorStats', data)
  },

  resetParamsForGetSupervisorStats (store) {
    store.commit('setIntervalForGetSupervisorStats', null)
    store.commit('setAgentForGetSupervisorStats', null)
    store.commit('setSkillForGetSupervisorStats', null)
  },

  updateGetSupervisorCsvStats (store, data) {
    store.commit('updateGetSupervisorCsvStats', data.data)
  },

  resetGetSupervisorCsvStats (store) {
    store.commit('updateGetSupervisorCsvStats', {})
  },

  setIntervalForGetSupervisorCsvStats (store, data) {
    store.commit('setIntervalForGetSupervisorCsvStats', data)
  },

  setAgentForGetSupervisorCsvStats (store, data) {
    store.commit('setAgentForGetSupervisorCsvStats', data)
  },

  setSkillForGetSupervisorCsvStats (store, data) {
    store.commit('setSkillForGetSupervisorCsvStats', data)
  },

  resetParamsForGetSupervisorCsvStats (store) {
    store.commit('setIntervalForGetSupervisorCsvStats', null)
    store.commit('setAgentForGetSupervisorCsvStats', null)
    store.commit('setSkillForGetSupervisorCsvStats', null)
  },

  updateGetNotes (store, data) {
    store.commit('updateGetNotes', data)
    router.push({
      path: '/notes'
    })
  },

  resetGetNotes (store) {
    store.commit('updateGetNotes', {
      cmd: 'get_notes',
      room: '',
      data: []
    })
  },

  updateRoomForGetNotes (store, data) {
    store.commit('updateRoomForGetNotes', data)
  },

  resetRoomForGetNotes (store) {
    store.commit('updateRoomForGetNotes', '')
  },

  updatePendingRequests (store, data) {
    let pending = store.getters.getPendingRequests
    pending[data.cmd] = data.state
    pending = JSON.parse(JSON.stringify(pending))
    store.commit('updatePendingRequests', pending)
  },

  setRoomForSendNote (store, data) {
    store.commit('setRoomForSendNote', data)
  },

  setSubjectForSendNote (store, data) {
    store.commit('setSubjectForSendNote', data)
  },

  setContentForSendNote (store, data) {
    store.commit('setContentForSendNote', data)
  },

  resetSendNoteRequest (store) {
    store.commit('setSubjectForSendNote', '')
    store.commit('setRoomForSendNote', '')
    store.commit('setContentForSendNote', '')
  },

  updateSendNoteResponse (store, data) {
    store.commit('updateSendNoteResponse', data)
  },

  increaseUnreadCount (store, room) {
    store.commit('updateUnreadCount', room)
  },

  resetUnreadCount (store, room) {
    store.commit('resetUnreadCount', room)
  },

  updateTime (store) {
    store.commit('updateTime')
  },

  updateGetZencalls (store, data) {
    store.commit('updateGetZencalls', data)
  },

  setRoomForLaunchZencall (store, data) {
    store.commit('setRoomForLaunchZencall', data)
  },

  setZencallForLaunchZencall (store, data) {
    store.commit('setZencallForLaunchZencall', data)
  },

  resetLaunchZencallRequest (store) {
    store.commit('setRoomForLaunchZencall', '')
    store.commit('setZencallForLaunchZencall', '')
  },

  updateLaunchZencallResponse (store, data) {
    store.commit('updateLaunchZencallResponse', data)
  },

  setContentForSendFiles (store, data) {
    let content
    let richContent = [
      {
        'kind': 'file',
        'file': {
          'name': data.txt,
          'url': data.url,
          'mimetype': data.mimetype
        }
      }
    ]
    content = data.txt
    store.commit('setContentForSendFiles', content)
    store.commit('setRichContentForSendFiles', richContent)
  },

  setRoomForSendFilesRequest (store, data) {
    store.commit('setRoomForSendFilesRequest', data)
  },

  resetSendFilesRequest (store) {
    store.commit('setRoomForSendFilesRequest', '')
    store.commit('setContentForSendFiles', '')
    store.commit('setRichContentForSendFiles', [])
  },

  updateCrmSearchResponse (store, data) {
    store.commit('updateCrmSearchResponse', data)
  },

  setRoomForSendPaymentRequest (store, data) {
    store.commit('setRoomForSendPaymentRequest', data)
  },

  sendPayment (store, data) {
    store.commit('sendPayment', data)
  },

  setRoomForAskAuthenticationRequest (store, data) {
    console.log('COMMIT', data)
    store.commit('setRoomForAskAuthenticationRequest', data)
  },

  setupAskAuthentication (store, data) {
    store.commit('setupAskAuthentication', data)
  }
}
